import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from '../Utils';


// Recipient
function pathAlertRecipientsGroups(groupId=null) {
  if (groupId) {
      return `alert-recipients-groups/${groupId}`;
  } else {
      return `alert-recipients-groups`;
  }
}

export function createAlertRecipientsGroups(successCallback, errorCallback, data) {
  postAuth({
    "path": pathAlertRecipientsGroups(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function patchAlertRecipientsGroups(successCallback, errorCallback, data, groupId) {
  patchAuth({
    "path": pathAlertRecipientsGroups(groupId),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function deleteAlertRecipientsGroups(successCallback, errorCallback, groupId) {
  deleteAuth({
    "path": pathAlertRecipientsGroups(groupId),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

export function getViewManageAlertRecipientsGroups(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/manage-alert-recipients-groups`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}


// Usage
export function patchUsageAlertsConfig(successCallback, errorCallback, data) {
  patchAuth({
    "path": `usage-alerts-config`,
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}

export function getViewUsageAlertsConfigShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(`view/usage-alerts-config-shforms`, qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}





